import React, { useState, useEffect } from "react";
import PersonalityUserCharts from "../UserCharts/PersonalityUserCharts";
import "./UserCharts.css";

const UserPersonalityVisualisation = ({ userData }) => {
  const [userScores, setUserScores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userData?.username) return;

  const fetchScores = async () => {
    try {
        const res = await fetch(
        `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/dashboard/personality-history`,
        { credentials: "include" }
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();

        setUserScores(data.scores || []);
    } catch (err) {
        console.error("Error fetching personality scores:", err);
        setUserScores([]);
    } finally {
        setLoading(false);
    }
    };


    fetchScores();
  }, [userData?.username]);

  if (loading) {
    return <div>Loading personality chart...</div>;
  }

  if (!userScores.length) {
    return <div>{userData.username} has not taken the personality quiz yet.</div>;
  }

  return <PersonalityUserCharts user={{ ...userData, scores: userScores }} />;
};

export default UserPersonalityVisualisation;
